import { render } from "./Build.vue?vue&type=template&id=c284a2fe"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__